export default __webpack_public_path__ + "static/media/01.822a9ea2.jpg";